export const SET_INIT_STATE  = 'SET_INIT_STATE';
export const SET_READY_STATE = 'SET_READY_STATE';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_ERROR_STATE = 'SET_ERROR_STATE';
export const SET_SUCCESS_STATE = 'SET_SUCCESS_STATE';

export const UPDATE_GLOBAL_CART = 'UPDATE_GLOBAL_CART';
